export default {
      id: "chevron-right-usage",
      viewBox: "0 0 10 17",
      url: __webpack_public_path__ + "svgsprite.svg#chevron-right",
      toString: function () {
        return this.url;
      }
    }